export var MessageTemplateScore;
(function (MessageTemplateScore) {
    MessageTemplateScore["GREEN"] = "GREEN";
    MessageTemplateScore["YELLOW"] = "YELLOW";
    MessageTemplateScore["RED"] = "RED";
    MessageTemplateScore["UNKNOWN"] = "UNKNOWN";
})(MessageTemplateScore || (MessageTemplateScore = {}));
